import { render, staticRenderFns } from "./shopManage.vue?vue&type=template&id=b3678284&scoped=true"
import script from "./shopManage.vue?vue&type=script&lang=js"
export * from "./shopManage.vue?vue&type=script&lang=js"
import style0 from "./shopManage.vue?vue&type=style&index=0&id=b3678284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3678284",
  null
  
)

export default component.exports